import { EnumSupportedSystem } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/SwapAgent';

export const getSupportedSystemDisplayValue = (
  value: number,
  translateFunc: (key: string) => string
) => {
  if (!EnumSupportedSystem[value]) return '';

  return translateFunc(`EnumSupportedSystem.${EnumSupportedSystem[value]}`);
};
